import { useEffect } from 'react';
import { useStore } from '../store/mst';

const useSubscribeToDriverChanges = (onDriverChange: () => void) => {
  const { subscription } = useStore();

  useEffect(() => {
    const unsubscribers = [
      subscription.onDriverEvent('DriverAddedDto', onDriverChange),
      subscription.onDriverEvent('DriverEditedDto', onDriverChange),
      subscription.onDriverEvent('DriverInviteAcceptedDto', onDriverChange),
      subscription.onDriverEvent('DriverProfileDeletedDto', onDriverChange),
    ];

    return () => unsubscribers.forEach(unsub => unsub());
  }, [subscription, onDriverChange]);
};

export default useSubscribeToDriverChanges;
